import React, { useState, Fragment, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Checkbox, DatePicker, Input, Select, Table,
} from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import H3FormInput from '@Uilib/h3FormInput';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3Text from '@Uilib/h3Text';

import './style.scss';
import PRZSelect from '../../../../Common/UI/PRZSelect';

const { Option } = Select;

const QCCustomInputs = ({
  customInputData, createQCPointLoading, updateCustomInputData, handleDelete, updateQCPointLoading, qcVerificationType,
}) => {
  const [isPlaceHolder, setIsPlaceHolder] = useState(false);

  function CheckCondition(record) {
    if (qcVerificationType === 'AUTOMATIC' && (record?.type === 'NUMBERS' || record?.type === 'DATE' || record?.type === 'DROPDOWN')) {
      return false;
    }

    return true;
  }

  const getCustomQCInputColumns = () => {
    const qcCustomInputsColumn = [
      {
        title: 'NAME',
        width: '200px',
        render: (record) => (
          <Fragment>
            <H3FormInput
              name="field name"
              type="text"
              containerClassName="orgInputContainer "
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => {
                const copyCustomInputData = JSON.parse(JSON.stringify(customInputData));
                copyCustomInputData.map((item) => {
                  if (item.key === record.key) {
                    item.name = event.target.value;
                  }
                  return customInputData;
                });
                updateCustomInputData(copyCustomInputData);
              }}
              value={record?.name}
              maxlength="100"

            />
            { !record?.showPlaceholder && (
              <H3Text
                text="+ Placeholder"
                onClick={(event) => {
                  const copyCustomInputData = JSON.parse(JSON.stringify(customInputData));
                  copyCustomInputData.map((item) => {
                    if (item.key === record.key) {
                      item.showPlaceholder = true;
                    }
                    return customInputData;
                  });
                  updateCustomInputData(copyCustomInputData);
                  setIsPlaceHolder(false);
                }}
                style={{
                  marginTop: '-15px',
                  paddingTop: '2px',
                }}
                className="table-subscript"
              />
            )}
            { record?.showPlaceholder && (
              <React.Fragment>
                <div className="orgFormLabel">
                  PLACEHOLDER
                  &nbsp;
                  <FontAwesomeIcon
                    icon={faXmark}
                    onClick={(event) => {
                      const copyCustomInputData = JSON.parse(JSON.stringify(customInputData));
                      copyCustomInputData.map((item) => {
                        if (item.key === record.key) {
                          item.showPlaceholder = false;
                          item.placeholder = null;
                        }
                        return customInputData;
                      });
                      updateCustomInputData(copyCustomInputData);
                    }}
                    color="red"
                    style={{
                      cursor: 'pointer',
                    }}
                  />
                </div>
                <H3FormInput
                  name="field placeholder"
                  type="text"
                  containerClassName="orgInputContainer"
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput"
                  placeholder=""
                  onChange={(event) => {
                    const copyCustomInputData = JSON.parse(JSON.stringify(customInputData));
                    copyCustomInputData.map((item) => {
                      if (item.key === record.key) {
                        item.placeholder = event.target.value;
                      }
                      return customInputData;
                    });
                    updateCustomInputData(copyCustomInputData);
                  }}
                  value={record?.placeholder}
                  maxlength="100"
                />
              </React.Fragment>
            )}
          </Fragment>
        ),
      },
      {
        title: 'TYPE',
        width: '150px',
        render: (record) => {
          const fieldTypeOptions = [
            { label: 'Text', value: 'TEXT' },
            { label: 'Number', value: 'NUMBERS' },
            { label: 'Dropdown', value: 'DROPDOWN' },
            { label: 'Attachment', value: 'ATTACHMENT' },
            { label: 'Textarea', value: 'TEXTAREA' },
            // { label: 'Checkbox', value: 'CHECKBOX' }, // Uncomment if needed
            { label: 'Date', value: 'DATE' },
          ];
          return (
            <Fragment>
              <div className="orgInputContainer">
                <PRZSelect
                  value={record?.type}
                  filterOption={false}
                  onChange={(value) => {
                    const copyCustomInputData = JSON.parse(JSON.stringify(customInputData));
                    copyCustomInputData.map((item) => {
                      if (item.key === record.key) {
                        item.type = value;
                        if (!item.pass_condition) {
                          item.pass_condition = {};
                        }
                        item.pass_condition.rule = null;
                        item.pass_condition.value_1 = null;
                        item.pass_condition.value_2 = null;
                      }
                      return customInputData;
                    });
                    updateCustomInputData(copyCustomInputData);
                  }}
                  options={fieldTypeOptions}
                />
              </div>
              {record?.type === 'DROPDOWN' && (
                <div className="orgInputContainer">
                  <label className="orgFormLabel">
                    Add Options
                  </label>
                  <PRZSelect
                    mode="tags"
                    value={record?.dropDown_values}
                    filterOption={false}
                    onChange={(value) => {
                      const copyCustomInputData = JSON.parse(JSON.stringify(customInputData));
                      copyCustomInputData.map((item) => {
                        if (item.key === record.key) {
                          item.dropDown_values = value;
                        }
                        return customInputData;
                      });
                      updateCustomInputData(copyCustomInputData);
                    }}
                    maxTagCount="responsive"
                    placeholder=""
                  />
                </div>
              )}
            </Fragment>
          )
        },
      },
      {
        title: 'REFERENCE VALUE',
        render: (record) => {
          const numberOrDateOperators = [
            { label: '<', value: '<' },
            { label: '>', value: '>' },
            { label: '=', value: '=' },
            { label: '<=', value: '<=' },
            { label: '>=', value: '>=' },
            { label: '!=', value: '!=' },
            { label: 'Between', value: 'BETWEEN' },
          ];
          const textOrDropdownOperators = [
            { label: 'IN', value: 'IN' },
            { label: 'NOT IN', value: 'NOT IN' },
          ];

          return (
          <Fragment>
            {CheckCondition(record) && (
              <H3FormInput
                name="field name"
                type="text"
                containerClassName="orgInputContainer"
                labelClassName="orgFormLabel"
                inputClassName="orgFormInput"
                placeholder=""
                onChange={(event) => {
                  const copyCustomInputData = JSON.parse(JSON.stringify(customInputData));
                  copyCustomInputData.map((item) => {
                    if (item.key === record.key) {
                      item.reference_value = event.target.value;
                    }
                    return customInputData;
                  });
                  updateCustomInputData(copyCustomInputData);
                }}
                value={record?.reference_value}
                maxlength="200"
              />
            )}
            {!CheckCondition(record) && (
              <div
                className="orgInputContainer"
                style={{
                  display: 'flex',
                  gap: '10px',

                }}
              >
                <PRZSelect
                  value={record?.pass_condition?.rule}
                  filterOption={false}
                  onChange={(value) => {
                    const copyCustomInputData = JSON.parse(JSON.stringify(customInputData));
                    copyCustomInputData.map((item) => {
                      if (item.key === record.key) {
                        item.pass_condition = {
                          rule: value,
                          value_1: null,
                          value_2: null,
                        };
                        item.is_required = true;
                      }
                      return customInputData;
                    });
                    updateCustomInputData(copyCustomInputData);
                  }}
                  style={{
                    width: '90px',
                  }}
                  options={
                    ['NUMBERS', 'DATE'].includes(record?.type)
                      ? numberOrDateOperators
                      : textOrDropdownOperators
                  }
                />
                {(record?.type !== 'DROPDOWN')
                && (
                  <H3FormInput
                    name={record?.pass_condition?.rule === 'BETWEEN' ? 'From' : 'Enter Value'}
                    type="text"
                    containerClassName=""
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput"
                    placeholder={record?.pass_condition?.rule === 'BETWEEN' ? 'From' : 'Enter Value'}
                    onChange={(event) => {
                      const copyCustomInputData = JSON.parse(JSON.stringify(customInputData));
                      copyCustomInputData.map((item) => {
                        if (item.key === record.key) {
                          // item?.pass_condition?.value_1 = event.target.value;
                          item.pass_condition.value_1 = event.target.value;
                        }
                        return customInputData;
                      });
                      updateCustomInputData(copyCustomInputData);
                    }}
                    value={record?.pass_condition?.value_1}
                    // maxlength="200"
                  />
                )}
                {(record?.type === 'DROPDOWN')
                && (
                  <PRZSelect
                    value={record?.pass_condition?.value_1 ? record?.pass_condition?.value_1 : []}
                    filterOption={false}
                    onChange={(value) => {
                      const copyCustomInputData = JSON.parse(JSON.stringify(customInputData));
                      copyCustomInputData.map((item) => {
                        if (item.key === record.key) {
                          // record?.pass_condition?.value_1 = value;
                          item.pass_condition.value_1 = value;
                        }
                        return customInputData;
                      });
                      updateCustomInputData(copyCustomInputData);
                    }}
                    style={{
                      width: '120px',
                      overflow: 'hidden',
                    }}
                    mode="tags"
                    maxTagCount="responsive"
                  >
                    {
                      record?.dropDown_values?.filter((item) => item.trim() !== '' || item === null).map((item) => (
                        <Option key={item} value={item}>{item}</Option>
                      ))
                    }
                  </PRZSelect>
                )}
                {(record?.pass_condition?.rule === 'BETWEEN' && record?.type !== 'DROPDOWN') && (
                  <H3FormInput
                    name="To"
                    type="number"
                    containerClassName="orgInputContainer"
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput"
                    placeholder={record?.pass_condition?.rule === 'DATE' ? 'To Date' : 'To'}
                    onChange={(event) => {
                      const copyCustomInputData = JSON.parse(JSON.stringify(customInputData));
                      copyCustomInputData.map((item) => {
                        if (item.key === record.key) {
                          // item?.pass_condition?.value_2 = event.target.value;
                          item.pass_condition.value_2 = event.target.value;
                        }
                        return customInputData;
                      });
                      updateCustomInputData(copyCustomInputData);
                    }}
                    value={record?.pass_condition?.value_2}
                    // maxlength="200"
                  />
                )}
              </div>
            )}
          </Fragment>
          )
        },
      },
      {
        title: 'REQUIRED',
        render: (record) => (
          <Fragment>
            <div
              className="orgInputContainer"
              style={{
                display: 'flex',
                justifyContent: 'space-around',
              }}
            >
              <Checkbox
                checked={record?.is_required}
                onChange={(event) => {
                  const copyCustomInputData = JSON.parse(JSON.stringify(customInputData));
                  copyCustomInputData.map((item) => {
                    if (item.key === record.key) {
                      item.is_required = event?.target?.checked;
                    }
                    return customInputData;
                  });
                  updateCustomInputData(copyCustomInputData);
                }}
              />
            </div>
          </Fragment>
        ),
      },
      {
        title: '',
        render: (text, record) => (
          <Fragment>
            <div className="qc-custom-inputs__delete-line" onClick={() => handleDelete(record.key)}>
              <CloseOutlined />
            </div>
          </Fragment>
        ),
        width: '40px',
      },
    ];

    return qcCustomInputsColumn;
  };

  return (
    <Fragment>
      <Table
        bordered
        loading={updateQCPointLoading || createQCPointLoading}
        showHeader
        size="small"
        scroll="scroll"
        columns={getCustomQCInputColumns()}
        dataSource={customInputData}
        pagination={false}
      />
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, QCPointReducers,
}) => ({
  user: UserReducers.user,
  createQCPointLoading: QCPointReducers.createQCPointLoading,
  updateQCPointLoading: QCPointReducers.updateQCPointLoading,
});

const mapDispatchToProps = (dispatch) => ({

});

QCCustomInputs.propTypes = {
  user: PropTypes.any,
  customInputData: PropTypes.any,
  handleDelete: PropTypes.any,
  updateCustomInputData: PropTypes.any,
  createQCPointLoading: PropTypes.bool,
  updateQCPointLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(QCCustomInputs));
